import { AlertTriangle, LoaderCircle, SearchX } from 'lucide-react';

function DataState({ type, title, message, actionLabel, onAction }) {
  const Icon = type === 'loading' ? LoaderCircle : type === 'error' ? AlertTriangle : SearchX;

  return (
    <div className={`data-state data-state-${type}`} role={type === 'error' ? 'alert' : 'status'}>
      <Icon className={type === 'loading' ? 'spin' : ''} aria-hidden="true" />
      <strong>{title}</strong>
      <span>{message}</span>
      {actionLabel && onAction && (
        <button className="button button-dark data-state-action" type="button" onClick={onAction}>
          {actionLabel}
        </button>
      )}
    </div>
  );
}

export default DataState;
